module.exports = __webpack_public_path__ + "img/toggle-left.7cf5551b.svg";